/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Reward category for promotion campaigns
 * Using string literal union to avoid type conflicts with PDS RewardCategory in generated clients
 * @export
 */
export const PromotionRewardCategory = {
    _11184809: '11184809',
    ENTRIES: 'ENTRIES',
    IN_STORE: 'IN_STORE',
    ONLINE: 'ONLINE',
    CASH: 'CASH',
    unknown_default_open_api: '11184809'
} as const;
export type PromotionRewardCategory = typeof PromotionRewardCategory[keyof typeof PromotionRewardCategory];


export function instanceOfPromotionRewardCategory(value: any): boolean {
    for (const key in PromotionRewardCategory) {
        if (Object.prototype.hasOwnProperty.call(PromotionRewardCategory, key)) {
            if (PromotionRewardCategory[key as keyof typeof PromotionRewardCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PromotionRewardCategoryFromJSON(json: any): PromotionRewardCategory {
    return PromotionRewardCategoryFromJSONTyped(json, false);
}

export function PromotionRewardCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionRewardCategory {
    return json as PromotionRewardCategory;
}

export function PromotionRewardCategoryToJSON(value?: PromotionRewardCategory | null): any {
    return value as any;
}

